import { createSlice } from '@reduxjs/toolkit';

export type UserState = {
  user: any;
};

const initialState: UserState = { user: null };

const usertokenSlice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    handleUserData(state, action) {
      state.user = action.payload;
    }
  }
});

export const { handleUserData } = usertokenSlice.actions;

export const userReducer = usertokenSlice.reducer;
